import { useEffect, useState } from 'react';
import { axios, IPostgreJobsAnalyticsPayload } from 'wisestep-api';

import { useComposableDashboardsFiltersContext } from '../../../../analyticsPage/hooks/useComposableDashboardsFiltersContext';
import { getDateRangeByTimePeriod } from '../../../utils/timeInfo';

export const usePostgreCvViewWidgetsData = <T>(
  query: IPostgreJobsAnalyticsPayload,
  defaultWidgetData: T
) => {
  const [widgetData, setWidgetData] = useState<T>(defaultWidgetData);
  const { restructuredFilters } = useComposableDashboardsFiltersContext();

  useEffect(() => {
    const controller = new AbortController();
    (async () => {
      try {
        const response = await axios.post(
          `/analyticsreportingapp/api/cv-view/composable-analytics/${query.type}`,
          {
            ...query,
            filters: [...(query.filters ?? []), ...restructuredFilters],
            ...getDateRangeByTimePeriod(query.range as string),
          },
          { signal: controller.signal }
        );
        setWidgetData(response.data ?? defaultWidgetData);
      } catch (error) {
        console.error('cv view analytics data fetch error', error);
      }
    })();

    return () => controller.abort();
  }, [defaultWidgetData, query, restructuredFilters]);

  return widgetData;
};
